import {Flurstueck} from "./flurstueck";

export class Flur{
  constructor() {
    this.flurstuecke.push(new Flurstueck())
  }
  id: string;
  number: string;
  flurstuecke: Array<Flurstueck> = [];
}
